"use strict";

import { on, find, trigger} from '../libs/@elements/dom-utils';
import {apiLoaded} from "../libs/@elements/ajax-form-map/ajax-form-google";
import {onFind} from "../libs/@elements/init-modules-in-scope";

// ajax-form classen auf geolocator umschreiben!

export function init () {
    // searchLocation
    apiLoaded().then(function () {
        let geocoder = new google.maps.Geocoder();

        onFind('.js-geolocator-search__submit-btn', function (item){
            on('click', function (){
                geocodeLocation(geocoder);
            }, item);
        });
    });
    // currentLocation
    onFind('.js-geolocator-current__btn', function (item) {
       on('click', function (evt) {
           console.log('clicked');
            // evt.preventDefault();
           let targetLatCurrent = find(item.getAttribute('data-target-lat'));
           let targetLngCurrent = find(item.getAttribute('data-target-lng'));
           navigator.geolocation.getCurrentPosition(
               function (position) {

                   targetLatCurrent.value = position.coords.latitude;
                   targetLngCurrent.value = position.coords.longitude;
                   console.log("targetLatBtn", targetLatCurrent.value);

                   trigger('submit', targetLngCurrent.closest('.js-geolocator__form'));
           });

       }, item);
    });
}

// searchLocation
function geocodeLocation(geocoder){
    let location = find('.js-geolocator-search__location-input').value;
    if(location){
        geocoder.geocode({
            'address': location,
            componentRestrictions: {
                country: 'AT'
            }
        }, function(results, status){
              if (status === 'OK') {
                onFind('.js-geolocator-search__location-input', function(item){
                    let targetLatInput = find(item.getAttribute('data-target-lat'));
                    let targetLngInput = find(item.getAttribute('data-target-lng'));

                    targetLatInput.value = results[0].geometry.location.lat();
                    targetLngInput.value = results[0].geometry.location.lng();
                });
            } else {
                alert('Geocode was not successful for the following reason: ' + status);
            }
        });

    }
}